import {useGetNotificationRuleListQuery} from 'src/redux/queries/notificationRule';
import {useGetSelectedField} from '../../../../../hooks/useFormBuilder';

export const useNotificationRules = () => {
  const field = useGetSelectedField();

  const {
    data: notificationRulePayload,
    isFetching: isNotificationRuleFetching,
    isLoading: isNotificationRuleLoading,
  } = useGetNotificationRuleListQuery({
    start: 0,
    length: 10000,
    formFieldInvariantId: field?.invariantId,
  });

  const isNotificationRulesLoading =
    isNotificationRuleFetching || isNotificationRuleLoading;
  const notificationRules = notificationRulePayload?.data ?? [];

  const hasActiveNotificationRules =
    !isNotificationRulesLoading && notificationRules.length > 0;

  return {
    notificationRules,
    isNotificationRulesLoading,
    hasActiveNotificationRules,
  };
};
